import {
  BaseOperacional,
  CidadesAtendidas,
  PrecoOrigemDestino,
} from "@/types/Endereco";
import api from "./api";

export const precosOrigemDestino = async (
  munCodigoOrigem: number
): Promise<PrecoOrigemDestino[]> => {
  const response = await api.get<PrecoOrigemDestino[]>(
    `/api_codehouse_origem_destino_precos_json.php?mun_codigo_origem=${munCodigoOrigem}`
  );
  // Garantir que sempre retornamos um array
  return Array.isArray(response.data) ? response.data : [];
};

export const cidadesRecomendadas = async (
  munCodigoOrigem: number
): Promise<CidadesAtendidas[]> => {
  const response = await api.get<CidadesAtendidas[]>(
    `/api_codehouse_site_cidades_atendidas_json.php?mun_codigo_origem=${munCodigoOrigem}`
  );
  // Garantir que sempre retornamos um array
  return Array.isArray(response.data) ? response.data : [];
};

export const enderecoBase = async (
  munCodigoOrigem: number
): Promise<BaseOperacional[]> => {
  const response = await api.get<BaseOperacional[]>(
    `/api_codehouse_site_base_principal_capital_json.php?mun_codigo_origem=${munCodigoOrigem}`
  );
  // Garantir que sempre retornamos um array
  return Array.isArray(response.data) ? response.data : [];
};
